var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.833008C13.4205 0.833008 14.167 1.57953 14.167 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V16.667C17.4998 18.0476 16.3806 19.167 15 19.167H5C3.6194 19.167 2.50018 18.0476 2.5 16.667V5C2.5 3.61929 3.61929 2.5 5 2.5H5.83301C5.83301 1.57953 6.57953 0.833008 7.5 0.833008H12.5ZM5 4.16699C4.53976 4.16699 4.16699 4.53976 4.16699 5V16.667C4.16717 17.1271 4.53987 17.5 5 17.5H15C15.4601 17.5 15.8328 17.1271 15.833 16.667V5C15.833 4.53976 15.4602 4.16699 15 4.16699H14.167L14.1582 4.33691C14.0729 5.17742 13.363 5.83301 12.5 5.83301H7.5C6.57963 5.83301 5.83318 5.08732 5.83301 4.16699H5ZM7.5 4.16699H12.5V2.5H7.5V4.16699Z",
    fill: "#192839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/TaskIcon.8ccfa0466b43f8a0c472a44b0f110e76.svg";
export { ForwardRef as ReactComponent };